import { Routes } from "@angular/router";

import { LoginComponent } from "./auth/login/login.component";
import { AdminGuard } from "./core/_guards/admin.guard";
import { AuthGuard } from "./core/_guards/auth.guard";
import { LoginGuard } from "./core/_guards/login.guard";
import { OwnerGuard } from "./core/_guards/owner.guard";

export const routes: Routes = [
  {
    path: "",
    redirectTo: "login",
    pathMatch: "full",
  },
  {
    path: "login",
    component: LoginComponent,
    canActivate: [LoginGuard],
    pathMatch: "full",
  },
  {
    path: "history",
    loadComponent: () =>
      import("./pages/history/history.component").then(a => a.HistoryComponent),
    pathMatch: "full",
    canActivate: [AuthGuard],
  },
  {
    path: "doc-upload",
    loadComponent: () =>
      import("./pages/doc-upload/doc-upload.component").then(
        a => a.DocUploadComponent
      ),
    pathMatch: "full",
    canActivate: [AuthGuard],
  },
  {
    path: "api-keys",
    loadComponent: () =>
      import("./pages/api-keys/api-keys.component").then(
        a => a.ApiKeysComponent
      ),
    pathMatch: "prefix",
    canActivate: [AuthGuard],
  },
  {
    path: "user-mgt",
    loadComponent: () =>
      import("./pages/user-mgt/user-mgt.component").then(
        a => a.UserMgtComponent
      ),
    pathMatch: "prefix",
    canActivate: [AdminGuard],
  },
  {
    path: "metrics",
    loadComponent: () =>
      import("./pages/metrics/metrics.component").then(a => a.MetricsComponent),
    pathMatch: "prefix",
    canActivate: [AuthGuard],
  },
  {
    path: "owner-mgt",
    loadComponent: () =>
      import("./pages/owner-mgt/owner-mgt.component").then(
        a => a.OwnerMgtComponent
      ),
    pathMatch: "prefix",
    canActivate: [OwnerGuard],
  },
  {
    path: "feature-flags",
    loadComponent: () =>
      import("./pages/feature-flags/feature-flags.component").then(
        a => a.FeatureFlagsComponent
      ),
    pathMatch: "prefix",
    canActivate: [OwnerGuard],
  },
  {
    path: "product-mgt",
    loadComponent: () =>
      import("./pages/product-mgt/product-mgt.component").then(
        a => a.ProductMgtComponent
      ),
    pathMatch: "prefix",
    canActivate: [AdminGuard],
  },
  { path: "**", redirectTo: "login" },
];
